export function monthYearToStartDate(value: string): string | null {
  const match = /^(0[1-9]|1[0-2])\/(\d{4})$/.exec(value);
  if (!match) return null;

  const year = Number(match[2]);
  const currentYear = new Date().getFullYear();
  if (year < 1900 || year > currentYear) return null;

  return `${match[2]}-${match[1]}-01`;
}

export function formatMonthYear(value: string): string {
  const digits = value.replace(/\D/g, "").slice(0, 6);
  return digits.length > 2
    ? `${digits.slice(0, 2)}/${digits.slice(2)}`
    : digits;
}
